import type { BadgeFlatDeprecated, BadgeProps, BadgePropsFlat } from '@/shared/types/badge';

const BADGE_CONSUMED_KEYS = new Set<string>([
  'appearance',
  'glyph',
  'text',
  'state',
  'className',
  'label',
  'color',
  'theme',
  'size',
  'stroke',
  'hover',
  'disabled',
  'customColor',
  'icon',
  'iconSlot',
  'iconDuotonePrimary',
  'iconDuotoneSecondary',
  'iconDuotoneOpacityPrimary',
  'iconDuotoneOpacitySecondary',
  'loading',
  'truncateLabel',
  'truncateTooltip',
]);

/**
 * Fusiona bloques agrupados con props planas (los bloques tienen prioridad).
 */
export function mergeGroupedBadgeProps(props: BadgeProps): BadgePropsFlat {
  const { appearance, glyph, text, state, className, ...rest } = props;
  const flat = rest as BadgeFlatDeprecated;

  return {
    className,
    label: text?.label ?? flat.label,
    color: appearance?.color ?? flat.color,
    theme: appearance?.theme ?? flat.theme,
    size: appearance?.size ?? flat.size,
    customColor: appearance?.customColor ?? flat.customColor,
    stroke: appearance?.stroke ?? flat.stroke,
    hover: state?.hover ?? flat.hover,
    disabled: state?.disabled ?? flat.disabled,
    icon: glyph?.icon ?? flat.icon,
    iconSlot: glyph?.iconSlot ?? flat.iconSlot,
    iconDuotonePrimary: glyph?.iconDuotonePrimary ?? flat.iconDuotonePrimary,
    iconDuotoneSecondary: glyph?.iconDuotoneSecondary ?? flat.iconDuotoneSecondary,
    iconDuotoneOpacityPrimary: glyph?.iconDuotoneOpacityPrimary ?? flat.iconDuotoneOpacityPrimary,
    iconDuotoneOpacitySecondary:
      glyph?.iconDuotoneOpacitySecondary ?? flat.iconDuotoneOpacitySecondary,
    loading: state?.loading ?? flat.loading,
    truncateLabel: text?.truncateLabel ?? flat.truncateLabel,
    truncateTooltip: text?.truncateTooltip ?? flat.truncateTooltip,
  };
}

/** Props que no deben propagarse al `<span>` (solo atributos nativos / handlers extra). */
export function omitBadgeConsumedProps(props: BadgeProps): Record<string, unknown> {
  const out: Record<string, unknown> = { ...(props as Record<string, unknown>) };
  for (const k of BADGE_CONSUMED_KEYS) {
    delete out[k];
  }
  return out;
}
